<mat-form-field appearance="outline" class="w-full">
    <mat-label>State</mat-label>
    <mat-select
        [ngModel]="stateProvinceId"
        (ngModelChange)="onInputChange($event)"
    >
        @for (stateProvince of stateProvinces; track stateProvince.id) {
            <mat-option value="{{ stateProvince.id }}">
                {{ stateProvince.name }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
